export default __webpack_public_path__ + "static/media/interaction.d3cf3a14.svg";